var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.backButton,
          expression: "backButton"
        }
      ],
      staticClass: "back-btn"
    },
    [
      _c("ul", { staticClass: "list-unstyled d-flex flex-wrap mx-n1" }, [
        _c(
          "a",
          {
            staticClass: "btn-white btn btn-sm shadow-sm",
            attrs: { href: _vm.href }
          },
          [
            _c("span", {
              staticClass:
                "png-icon png-icon-icons-glyph--k-arrow-left-sm mb-1 ml-0 mr-0"
            }),
            _vm._v(" "),
            _c("span", [_vm._v("   ")]),
            _vm._v("\n      BACK TO RESULTS\n    ")
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }